import { defineStore } from "pinia";
import { IPluginOptions } from "@/schemas/pluginOptions/pluginOptionsSchema";
interface State {
  carousel?: boolean;
  rating?: boolean;
}

export const useBetaFeaturesStore = defineStore("betaFeatures", {
  state: (): State => ({
    carousel: false,
    rating: false,
  }),

  actions: {
    setBetaFeatures(betaFeatures: IPluginOptions["betaFeatures"]) {
      this.carousel = betaFeatures?.carousel;
      this.rating = betaFeatures?.rating;
    },
  },
});
